import axios from "axios";
import restfulApi from "@/api/restfulApi";

const refreshApi = axios.create()

const loadRefreshLink = () => axios.get(restfulApi.getRoot())
  .catch(reject => {
    restfulApi.configureRestfulData(reject.response.data)
    return restfulApi.getLink('token_refresh', 'POST')
  })

const refreshToken = (link, refresh) => refreshApi.post(link, {refresh})
  .then(response => response && response.status === 200 ? response.data : false)


export default function refreshTokenApi(refresh) {
  let refreshLink = restfulApi.getLink('token_refresh', 'POST')

  if (refreshLink) {
    return refreshToken(refreshLink, refresh)
  }

  return loadRefreshLink().then(link => refreshToken(link, refresh))

}
